import { render } from "./ApplianceStatusWidget.vue?vue&type=template&id=8c261b36"
import script from "./ApplianceStatusWidget.vue?vue&type=script&lang=js"
export * from "./ApplianceStatusWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__